import type { ApiError } from '@/api/backend/types';
import { getLocalizedValue } from '@/lib/utils';
import { isAxiosError, type AxiosRequestConfig } from 'axios';

export const gupRequestConfig: AxiosRequestConfig = {
  responseInterceptorConfig: { ignoreStatusCodes: [400, 403, 404, 409, 422, 500, 503] },
};

const workflowFailureStatuses = [400, 403, 409, 422];

export const isGupWorkflowFailure = (error: unknown): boolean =>
  isAxiosError(error) &&
  workflowFailureStatuses.includes(error.response?.status ?? 0) &&
  (error.config?.url ?? '').includes('/workflow/');

export const isGupAccessDenied = (error: unknown): boolean =>
  isAxiosError<{ code?: string }>(error) && error.response?.data?.code === 'ERR_ACCESS_DENIED';

export const isGupCompanyProfileError = (error: unknown): boolean =>
  isAxiosError<{ code?: string }>(error) && error.response?.data?.code === 'ERR_INVESTOR_COMPANY_SERVICE';

export const getGupErrorMessage = (error: unknown, lang: string): string | undefined => {
  if (!isAxiosError<ApiError>(error)) return;
  const message = error.response?.data?.message;
  return message ? getLocalizedValue(message, lang) : undefined;
};

export const getGupTaskErrorText = (error: unknown, lang: string, failed: string): string => {
  if (isAxiosError(error)) return getGupErrorMessage(error, lang) ?? failed;
  return error instanceof Error && error.message ? error.message : failed;
};
